const CHECKED_ICON_COLOR = "#41b167";

export { CHECKED_ICON_COLOR };
